import Header from "./components/Header";
import Hero from "./components/Hero";
import CardsSection from "./components/sections/CardsSection";
import AppSection from "./components/sections/AppSection";
import AboutSection from "./components/sections/AboutSection";
import UpdatesSection from "./components/sections/UpdatesSection";
import IndexSection from "./components/sections/IndexSection";
import FAQSection from "./components/sections/FAQSection";
import CarouselSection from "./components/sections/CarouselSection";
import TopicsSection from "./components/sections/TopicsSection";
import ContactSection from "./components/sections/ContactSection";
import RankingSection from "./components/sections/RankingSection";
import CommentsSection from "./components/sections/CommentsSection";
import MediaSection from "./components/sections/MediaSection";
import FeaturesSection from "./components/sections/FeaturesSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <AppSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <FAQSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <RankingSection />
        <CommentsSection />
        <MediaSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}